import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type PaneType = 'left' | 'right';

@Component({
  selector: 'craft-slide-panel',
  templateUrl: './craft-slide-panel.component.html',
  styleUrls: ['./craft-slide-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CraftSlidePanelComponent {
  @Input() public activePane: PaneType = 'left';
}
